import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../../../redux/store";
import {
  apartmentStepSet,
  enteredViaLinkSet,
} from "../../../../../redux/slice/apartmentRental/apartmentRentalSlice";
import { BookingCreationStep } from "../../bookingCreationStep";
import ListLoadError from "../ListLoadError";

/**
 * What a room-family flow shows when its object search failed — on the
 * selection step AND on any later step a deep link can land on (#2793).
 *
 * The wording depends on HOW THE CUSTOMER ARRIVED, not on how the search
 * failed. A failed search says nothing about its cause, and a customer who
 * clicked the flow from its start has no link to blame. But one who came in
 * through a link that already carried a search — a bookmark, a shared link, a
 * reload — is told that the link could not be opened, and that a SAVED link
 * can be out of date and is worth replacing once the new search has given
 * them a fresh one. Everyone else gets the flow's own "could not be loaded".
 *
 * Both offer "search again": back to the first step with the fields still
 * filled in. Restarting is always a legitimate way out, and without a button
 * the customer has to find it. After it the customer is in a clicked flow, so
 * the link explanation no longer applies.
 */
interface ObjectSearchFailureProps {
  /** The flow's own wording, e.g. `book_location.error.fetch_venues`. */
  errorMessageKey: string;
}

const ObjectSearchFailure = ({ errorMessageKey }: ObjectSearchFailureProps) => {
  const dispatch = useDispatch();
  const enteredViaLink = useSelector(
    (state: RootState) => state.apartment.enteredViaLink
  );

  return (
    <ListLoadError
      messageKey={
        enteredViaLink ? "book_location.error.link_unresolved" : errorMessageKey
      }
      action={{
        labelKey: "book_location.error.restart_search",
        onClick: () => {
          dispatch(enteredViaLinkSet(false));
          dispatch(apartmentStepSet(BookingCreationStep.locationSelection));
        },
      }}
    />
  );
};

export default ObjectSearchFailure;
